import styled from 'styled-components';
import { Button } from '@bechtel/gds';

export const EmulateButtonStyled = styled(Button)`
  min-width: 100px;
  background-color: ${({ theme }) => theme.colors.green[500]};
  box-shadow: none;
  &:hover {
    background-color: ${({ theme }) => theme.colors.green[500]};
  }
  &:active {
    background-color: ${({ theme }) => theme.colors.green[500]};
  }
`;
